import { render, staticRenderFns } from "./cause-list.vue?vue&type=template&id=39f4efa2&scoped=true&"
import script from "./cause-list.vue?vue&type=script&lang=js&"
export * from "./cause-list.vue?vue&type=script&lang=js&"
import style0 from "./cause-list.vue?vue&type=style&index=0&id=39f4efa2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f4efa2",
  null
  
)

export default component.exports